import PropTypes from 'prop-types'
import React from 'react'
import css from './SignupUserStep.module.css'
import t from 'tcomb-form'
import Form from 'ui/Form'
import { space } from 'ui/variables'
import Button from 'ui/Button'
import Space from 'ui/Space'
import LoggedOutHeader from './LoggedOutHeader'
import SignupAlert from './SignupAlert'
import Link from 'ui/Link'
import {
  Email,
  Password,
  booleanRadioTransformer,
  horizontalRadiosTemplate
} from 'lib/tcomb-types'

const InviteSchema = t.struct({
  email: Email,
  first_name: t.String,
  last_name: t.String,
  password: Password
})

const RegularSchema = InviteSchema.extend({
  source: t.maybe(t.String),
  is_company: t.Boolean
})

const formLayout = (locals) => (
  <div>
    {locals.inputs.email}

    {/* .form-group is from tcomb */}
    <div className={`form-group ${css.horizontalInputs}`}>
      <div className={css.horizontalInput}>{locals.inputs.first_name}</div>
      <div className={css.horizontalInput}>{locals.inputs.last_name}</div>
    </div>

    {locals.inputs.password}
    {locals.inputs.source}
    {locals.inputs.is_company}
  </div>
)

const formOptions = {
  template: formLayout,
  fields: {
    email: {
      type: 'email',
      label: 'Your work email',
      attrs: {
        placeholder: 'you@company.com'
      }
    },
    first_name: {
      type: 'text',
      label: 'First name',
      attrs: {
        placeholder: 'Oscar'
      },
      error: 'Please enter your first name.'
    },
    last_name: {
      type: 'text',
      label: 'Last name',
      attrs: {
        placeholder: 'Jones'
      },
      error: 'Please enter your last name.'
    },
    password: {
      type: 'password',
      label: 'Password',
      help: (
        <div>
          <Space value={7} />
          <p>Make sure it’s at least 8 characters long and includes at least 1 number.</p>
        </div>
      ),
      attrs: {
        placeholder: 'Enter a secure password'
      }
    },
    source: {
      type: 'text',
      label: 'How did you hear about us?',
      attrs: {
        placeholder: 'e.g. friend, blog'
      }
    },
    is_company: {
      factory: t.form.Radio,
      transformer: booleanRadioTransformer,
      template: horizontalRadiosTemplate,
      label: 'Who are you creating an account for?',
      error: 'Please select an option.',
      options: [
        { value: 'false', text: 'Just for me' },
        { value: 'true', text: 'My company' }
      ]
    }
  }
}

const SignupUserStep = props => {
  const {
    existingEmail,
    enable,
    formData,
    invite,
    inviteType,
    isLoading,
    onChange,
    onSubmit,
    onEmailBlur
  } = props
  let emailError

  if (existingEmail) {
    emailError = (
      <span>
        The email address {existingEmail} is already in use. Want to <Link href='/login'>login</Link> instead?
      </span>
    )
  }

  const schema = invite ? InviteSchema : RegularSchema
  const options = {
    ...formOptions,
    fields: {
      ...formOptions.fields,
      email: {
        ...formOptions.fields.email,
        error: emailError,
        hasError: Boolean(existingEmail),
        attrs: {
          ...formOptions.fields.email.attrs,
          onBlur: e => onEmailBlur(e.target.value),
          readOnly: Boolean(invite)
        }
      }
    }
  }

  return (
    <div>
      <LoggedOutHeader title='Create your Segment account' />

      <p className={css.loginMessage}>
        Already have an account?{' '}
        <Link href='/login' icon='rightArrow'>Log in</Link>
      </p>

      <SignupAlert invite={invite} inviteType={inviteType} enable={enable} />

      <Form
        schema={schema}
        options={options}
        values={formData}
        onSubmit={onSubmit}
        onChange={onChange}>

        <Space value={space[4]} />

        <Button
          type='submit'
          extras='fluid'
          loading={isLoading}
          disabled={Boolean(existingEmail)}> {/* tcomb doesn't prevent submission on hasError */}
          {invite ? 'Create your account' : 'Next'}
        </Button>
      </Form>

      <p className={css.terms}>
        Signing up signifies you’ve read and agree to our
        {' '}
        <Link href='https://segment.com/docs/legal/terms/' target='_blank'>Terms of Service</Link>
        {' '}
        and
        {' '}
        <Link href='https://segment.com/docs/legal/privacy/' target='_blank'>Privacy Policy</Link>.
      </p>
    </div>
  )
}

SignupUserStep.propTypes = {
  existingEmail: PropTypes.string,
  enable: PropTypes.object,
  formData: PropTypes.object.isRequired,
  invite: PropTypes.object,
  inviteType: PropTypes.string,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
}

export default SignupUserStep



// WEBPACK FOOTER //
// ./components/SignupUserStep.js